import React from "react";
import { toast } from "react-hot-toast";

type CopyToClipboardProps = {
  text: string;
  children: React.ReactNode;
  onCopy?: () => void; // make it optional
};

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  text,
  children,
  onCopy,
}) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard");
      if (onCopy) onCopy(); // fire external handler if provided
    } catch (err) {
      toast.error("Failed to copy");
      console.error(err);
    }
  };

  return (
    <div onClick={handleCopy} className="cursor-pointer">
      {children}
    </div>
  );
};

export default CopyToClipboard;
